import { LOCALES } from 'i18n/locales';

export const supplementaryDataTab = {
    [LOCALES.ENGLISH]: {
        'supplementaryDataTab.externalResources': 'External Resources',
        'supplementaryDataTab.externalResourcesGuidance': 'Guidance',
        'supplementaryDataTab.linkedFile.error.text': 'Unable to open this file. Please try again, or contact the service desk if the issue persists.'
    },
    [LOCALES.WELSH]: {
        'supplementaryDataTab.externalResources': 'Adnoddau Allanol',
        'supplementaryDataTab.externalResourcesGuidance': 'Cyfarwyddyd',
        'supplementaryDataTab.linkedFile.error.text': 'Ddim yn gallu agor y ffeil hon. Rhowch gynnig arni eto, neu cysylltwch a\'r ddesg gwasanaeth ow yw\'r broblem yn parhau.'
    }
};
